export const python = {
  text: "Now use the following snippet:",
  code: `<pre class="python" >
import finbox_bankconnect as fbc  

#set API Key
fbc.api_key = "YOUR_API_KEY"   

#create an entity object
entity = fbc.Entity.create()  

#upload a statement pdf
entity.upload_statement('PATH_TO_FILE.pdf')  

#fetch identity information for the entity
identity_dict = entity.get_identity() 

#printing the identity information
print(identity_dict)
</pre>`,
};
export const java = {
  text:
    "You can use OkHttp in upload a statement and print the identity information extracted from the statement",
  code: `<pre class="java"  >
public class FinBoxTest{
  public static void main(String []args){
      OkHttpClient client = new OkHttpClient().newBuilder().build();
      MediaType mediaType = MediaType.parse("text/plain");
      RequestBody body = new MultipartBody.Builder().setType(MultipartBody.FORM)
        .addFormDataPart("file", "filename.pdf",
          RequestBody.create(MediaType.parse("application/octet-stream"),
            new File("PATH_TO_FILE.pdf")))
          .addFormDataPart("link_id", "your_link_id")
        .build();
      Request request = newRequest.Builder()
        .url("https://portal.finbox.in/bank-connect/v1/statement/bankless_upload/?identity=true")
        .method("POST", body)
        .addHeader("x-api-key", "YOUR_API_KEY")
        .build();
      Response response = client.newCall(request).execute();
      System.out.println(response.body().string());
  }
}
    </pre>`,
};
export const nodejs = {
  text:
    "You can use request to upload a statement and print the identity information extracted from the statement",
  code: `<pre >
var request = require("request");
var fs = require("fs");
var options = {
    method: "POST",
    url: "https://portal.finbox.in/bank-connect/v1/statement/bankless_upload/?identity=true",
    headers: { "x-api-key": "YOUR_API_KEY" },
    formData: {
        file: {
            value: fs.createReadStream("PATH_TO_FILE.pdf"),
            options: { filename: "filename.pdf" },
      },
    },
  };
request(options, function (error, response) {
    if (error) throw new Error(error);
        console.log(response.body);
});
    </pre>`,
};
export const ruby = {
  text: "",
  code: `<pre class="ruby style=" >
require "url"
require "net/http"

url = URI("https://portal.finbox.in/bank-connect/v1/statement/bankless_upload/?identity=true")

https = Net::HTTP.new(url.host, url.port);
https.use_ssl=true

request = Net::HTTP::Post.new(url)
request["x-api-key"] ="YOUR_API_KEY"
form_data = [['file', File.open('PATH_TO_FILE.pdf')]]
request.set_formform_data, 'multipart/form-data'
response=https.request(request)
putsresponse.read_body
</pre>`,
};
export const go = {
  text: "",
  code: `<pre >
package main 

import (
"fmt"
"bytes"
"mime/multipart"
"os"
"io"
"net/http"
"io/ioutil"
)

func main() { 
  
  url := "https://portal.finbox.in/bank-connect/v1/statement/bankless_upload/?identity=true"
  method := "POST"
  
  payload := &bytes.Buffer{}
  writer := multipart.NewWriter(payload)
  file, errFile1 := os.Open("PATH_TO_FILE.pdf")
  deferfile.Close()
  part1, errFile1 := writer.CreateFormFile("file","filename.pdf")
  _, errFile1 = io.Copy(part1, file)
  if errFile1! = nil {
    fmt.Println(errFile1)
  }
  err := writer.Close()
  iferr != nil {
    fmt.Println(err)
  }
  client := &http.Client {}
  req, err :=http.NewRequest(method, url, payload)
  
  if err != nil {
    fmt.Println(err)  
  }
  req.Header.Add("x-api-key", "YOUR_API_KEY")
  
  req.Header.Set("Content-Type", writer.FormDataContentType())
  res, err :=client.Do(req)
  deferres.Body.Close()
  body, err :=ioutil.ReadAll(res.Body)
  
  fmt.Println(string(body))
}
      </pre> `,
};
